"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOLGuestAuthHeaders = void 0;
const mol_security_headers_1 = require("./mol-security-headers");
/**
 * LifeSG users, logged in via Singpass
 */
class MOLGuestAuthHeaders {
    constructor(props) {
        Object.assign(this, props);
    }
    static from(headers) {
        return new MOLGuestAuthHeaders({
            [mol_security_headers_1.MOLSecurityHeaderKeys.GUEST_ID]: headers[mol_security_headers_1.MOLSecurityHeaderKeys.GUEST_ID],
        });
    }
}
exports.MOLGuestAuthHeaders = MOLGuestAuthHeaders;
mol_security_headers_1.MOLSecurityHeaderKeys.GUEST_ID;
//# sourceMappingURL=MOLGuestAuthHeaders.js.map